<template>
    <div>
        <div class="row">
            
        </div>
        <div class="row my-3">
            <div class="panel panel-inverse col col-md-6">
                <div class="panel-heading">
                    Rendszerüzenetek
                </div>
                <div class="panel-body">
                    <div v-if="systemMessages.length === 0" class="alert alert-info">
                        Nincsenek rendszerüzenetek
                    </div>
                    <div v-else>
                        <div class="alert" v-for="message in systemMessages" :key="message.id" :class="alertClass(message.priority)">
                            {{ message.message }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel panel-inverse col col-md-6">
                <div class="panel-heading">
                    Válassz applikációt
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div v-for="(appMode, index) in appModes" :key="index"
                            v-show="user.available_modes.includes(appMode.mode)" class="col-6 p-2">

                            <img :src="require(`@/assets/img/${appMode.logo}`)" class="img-fluid cursor-pointer"
                                @click="setMode(appMode.mode)"
                                :style="{ filter: mode !== appMode.mode ? 'grayscale(100%)' : 'none' }" />
                        </div>
                    </div>
                </div>            
            </div>
            
        </div>

    </div>
</template>
<style>
.centered-div {
    width: 50%;
    margin: 0px auto;
}
</style>
<script>
import SystemMessage from '../apis/SystemMessage';

export default {
    data() {
        return {
            systemMessages: [],
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        mode() {
            return this.$store.state.mode;
        },
        appModes() {
            return this.$store.state.appModes;
        },
    },
    created() {
        SystemMessage.indexSelector()
            .then(response => {
                this.systemMessages = response.data;
            });
        /* 
                User.getAvailableApps()
                    .then(response => {
                        this.availableApps = response.data;
                    }); */
        
    },
    methods: {
        setMode(modeval) {
            this.$store.commit("updateMode", modeval);
        },
        alertClass(priority) {
            switch (priority) {
                case 1:
                    return 'alert-info';
                case 2:
                    return 'alert-warning';
                case 3:
                    return 'alert-danger';
                default:
                    return 'alert-info';
            }
        }
    }
};
</script>